export default "https://3153518b.brand-approval-forms.pages.dev/static/img/decline-icon.svg"